/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     DetailField
//   Details:    Detail field (single row) for MyDetails
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101886 02/07/19 JHT M01  Added requiresImageOnChange
// 103839 06/04/20 JC  M02  React upgrade
// 108107 01/06/20 JC  M03  Original value now passed in
// 108238 08/06/20 JC  M04  Use react-datetime component for datetime
// WI3029 31/05/23 JC  M05JC	handleChecked now passes newValue as String to props.changed
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//M04 import DateLabel from '../components/DateLabel'; //M04
//M04 import DateTimeLabel from '../components/DateTimeLabel'; //M04
import DateTime from '../components/DateTime'; //M04
import { dateTimeTypes } from '../constants/DateTimeTypes'; //M04
import './css/DetailField.css';
import { utils } from '../utils/utils'; //M03

class DetailField extends Component {
	constructor(props) {
		super(props);

		const decimalPlaces = this.getDecimalPlaces(props.item.dataType);
		const inputType = this.getInputType(props.item.dataType);
        const value = utils.formatValue(props.item.value, inputType, decimalPlaces); //M02
        const originalValue = utils.formatValue(props.item.originalValue, inputType, decimalPlaces); //M02
		this.state = {
			inputType,
			decimalPlaces,
            originalValue: originalValue, //M03 was value
			value: value,
			isPending: props.item.isPending,
            isChanged: false,
            propsediting: false, //M02
            propstimestamp: 0 //M02
		};

		this.handleSelect = this.handleSelect.bind(this);
		this.handleChecked = this.handleChecked.bind(this);
		this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleDatetimeChange = this.handleDatetimeChange.bind(this); //M04
        this.handleDatetimeBlur = this.handleDatetimeBlur.bind(this); //M04
	}

    //M02
	//componentWillReceiveProps(nextProps) {
	//	const value = this.formatValue(nextProps.item.value, this.state.inputType, this.state.decimalPlaces);
	//	this.setState({
	//		value: value,
	//		originalValue: value,
	//		isPending: nextProps.item.isPending,
	//		isChanged: false
	//	});
 //   }

    //M02
    static getDerivedStateFromProps(props, state) {
        let item = props.item;
        let value = utils.formatValue(item.value, state.inputType, state.decimalPlaces);
        let originalValue = utils.formatValue(item.originalValue, state.inputType, state.decimalPlaces);//M03

        //only if props editing changed, or timestamp refreshed
        if (props.editing !== state.propsediting || 
            props.timestamp !== state.propstimestamp) {

            //return new state
            return {
                value: value,
                originalValue: originalValue, //M03 was value
                isPending: item.isPending,
                isChanged: false,
                propsediting: props.editing,
                propstimestamp: props.timestamp
            };
        }

        // Return null to indicate no change to state.
        return null;
    }

	dataTypes = ["text", "checkbox", "date", "datetime", "select", "number", "number", "number", "number", "number"];

	getInputType(dataType) {
		if (dataType >= 1 && dataType <= 10)
			return this.dataTypes[dataType - 1];
		return "text";
	}

	getDecimalPlaces(dataType) {
		if (dataType >= 6 && dataType <= 10)
			return dataType - 6;
		return null;
	}

    ///M02 moved to utils
	//formatValue(value, inputType, decimalPlaces) {
	//	if (inputType === "checkbox") {
	//		return value.toLowerCase() === "true" ? true : false;
	//	}
	//	else if (inputType === "number") {
	//		var numeric = parseFloat(value);
	//		return isNaN(numeric)
	//			? ""
	//			: numeric.toFixed(decimalPlaces);
	//	}
	//	return value;
	//}

	handleSelect = event => {
		var newValue = event.target.value;
		var isChanged = newValue !== this.state.originalValue;
		this.setState({
			value: newValue,
			isChanged: isChanged
		});
        this.props.changed({ key: this.props.item.key, isChanged, value: newValue, dataType: this.props.item.dataType, requiresImageOnChange: this.props.item.requiresImageOnChange }); //M01
	}

	handleChecked = event => {
		var newValue = event.target.checked;
		var isChanged = newValue !== this.state.originalValue;
		this.setState({
			value: newValue,
			isChanged: isChanged
		});
		this.props.changed({
			key: this.props.item.key, isChanged, value: newValue.toString(), //M05JC convert new value to string
			dataType: this.props.item.dataType, requiresImageOnChange: this.props.item.requiresImageOnChange
		}); //M01
	}

	handleChange = event => {
		this.setState({
            value: event.target.value
		});
	}

	handleBlur = event => {
		event.preventDefault();
		var newValue = utils.formatValue(event.target.value, this.state.inputType, this.state.decimalPlaces); //M02 M04
		var isChanged = newValue !== this.state.originalValue;
		this.setState({
			value: newValue,
            isChanged: isChanged
		});
        this.props.changed({ key: this.props.item.key, isChanged, value: newValue, dataType: this.props.item.dataType, requiresImageOnChange: this.props.item.requiresImageOnChange }); //M01
    }

    //M04
    handleDatetimeChange = momentDate => {
        this.setState({
            value: momentDate
        });
    }

    //M04
    handleDatetimeBlur = momentDate => {
        var newValue = utils.formatValue(momentDate, this.state.inputType, this.state.decimalPlaces); //M04
        var isChanged = newValue !== this.state.originalValue;
        this.setState({
            value: newValue,
            isChanged: isChanged
        });
        this.props.changed({ key: this.props.item.key, isChanged, value: newValue, dataType: this.props.item.dataType, requiresImageOnChange: this.props.item.requiresImageOnChange }); //M01
    }

	render() {
		const { item } = this.props;
		const detailChangedClass = this.state.isChanged ? "detail-changed" : "";
		const detailPendingClass = this.props.item.isPending ? "detail-pending" : "";
		if (!this.props.editing) {
            var field;
            /* M04 just use datetime component
			if (this.state.inputType === "date") {
				field = <DateLabel date={this.state.value} />;
			}
			else if (this.state.inputType === "datetime") {
				field = <DateTimeLabel date={this.state.value} />;
			}
             */
            /* M04 */
            if (this.state.inputType === "date" || this.state.inputType === "datetime") {

                //get the correct date time type
                let dateTimeType = dateTimeTypes.dateTime;
                if (this.state.inputType === "date") { dateTimeType = dateTimeTypes.date }

                field = <DateTime
                    componentKey={item.key}
                    componentName={item.key}
                    value={this.state.value}
                    dateTimeType={dateTimeType}
                    disabled={true}
                />

            }
			else if (this.state.inputType === "checkbox") {
				field = this.state.value ? "Yes" : "No";
			}
			else {
				field = <span>{this.state.value}</span>;
			}

			return (
				<div className={`detail-field ${detailChangedClass} ${detailPendingClass}`}>{field}</div>
			);
		}
		
        if (this.state.inputType === "select") {
            var options = ["", ...item.validValues.split(',')];
            return (
                <select
                    key={item.key}
                    name={item.key}
                    onChange={this.handleSelect}
                    value={this.state.value}
                    className={`detail-field ${detailChangedClass} ${detailPendingClass}`}
                >
                    {options.map((opt, i) => <option key={opt}>{opt}</option>)}
                </select>
            );
        }
        else if (this.state.inputType === "checkbox") {
            return (
                <input
                    type="checkbox"
                    key={item.key}
                    name={item.key}
                    onChange={this.handleChecked}
                    value="true"
                    checked={this.state.value}
                    className={`detail-field ${detailChangedClass} ${detailPendingClass}`}
                />
            );
        }
        /* M04 date /datetime handling - use datetime component */
        else if (this.state.inputType === "date" || this.state.inputType === "datetime") {

            //get the correct date time type
            let dateTimeType = dateTimeTypes.dateTime;
            if (this.state.inputType === "date") { dateTimeType = dateTimeTypes.date }

            return (<DateTime
                componentKey={item.key}
                componentName={item.key}
                className={`detail-field ${detailChangedClass} ${detailPendingClass}`}
                value={this.state.value}
                onBlur={this.handleDatetimeBlur}
                onChange={this.handleDatetimeChange}
                dateTimeType={dateTimeType}
                disabled={false}
            />
            );
        }
		return (
			<div>
				<input
					type={this.state.inputType}
					key={item.key}
					name={item.key}
					value={this.state.value}
					onBlur={this.handleBlur}
					onChange={this.handleChange}
					className={`detail-field ${detailChangedClass} ${detailPendingClass}`}
				/>
			</div>
		);
	}
}


DetailField.propTypes = {
	item: PropTypes.shape({
		key: PropTypes.string.isRequired,
		dataType: PropTypes.number.isRequired,
		validValues: PropTypes.string,
		value: PropTypes.any,
        requiresImageOnChange: PropTypes.bool.isRequired, //M01
		isPending: PropTypes.bool.isRequired
	}),
	changed: PropTypes.func.isRequired
};

export default connect()(DetailField);
